import { Link } from "gatsby";
import styled from "styled-components";
import { Background, NonSelectable, Preserve3dMixin } from "styled/common/Utils";
import { CommonLink, StandardFont } from "styled/common/font-styles/CommonFonts";
import { CalculateFontSize, CalculateFromHeight, CalculateFromWidth } from "styled/base/SizeFunctions";

export const CookieNotificationParent = styled.div`
  width: 100%;
  height: 100vh;
  min-height: -moz-available;
  max-height: 100vh;
  position: fixed;
  pointer-events: none;
  position: fixed;
  ${Background};
  ${Preserve3dMixin};
`;

export const CookieNotificationWrapper = styled.div`
  background-color: rgba(0.5, 0.5, 0.5, 0.8);
  width: 100%;
  z-index: 999;
  transform: translateZ(11px);
  pointer-events: all;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);

  ${({ theme: { breakpoints } }) => breakpoints.desktop} {
    display: flex;
    justify-content: center;
    flex-direction: row;
  }
  ${({ theme: { breakpoints } }) => breakpoints.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    ${Preserve3dMixin}
  }
  ${({ theme: { breakpoints } }) => breakpoints.mobile} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    ${Preserve3dMixin}
  }
  ${CalculateFromHeight("margin-top", { mobile: -15, tablet: -7, desktop: -4 })}
  ${CalculateFromHeight("height", { mobile: 15, tablet: 7, desktop: 4 })}
  & a {
    pointer-events: all;
  }
`;

export const CookieButton = styled.button`
  display: inline-flex;
  height: 100%;
  ${({ theme: { breakpoints } }) => breakpoints.desktop} {
    align-items: center;
    align-content: center;
    padding-right: 1vw;
  }

  ${({ theme: { breakpoints } }) => breakpoints.tabletMobile} {
    grid-row: 2 / span 1;
    grid-column: 1 / span 2;
    margin-left: auto;
    margin-right: auto;
  }
  ${CalculateFromWidth("margin-left", { desktop: 0.5 })}
  ${CalculateFromHeight("margin-top", { desktop: 0.1 })}
  ${CalculateFontSize("font-size", { mobile: 1.2, tablet: 1.2, desktop: 1.24 })}
`;

export const CookieButtonLink = styled.p`
  display: inline;
  margin: auto 0;
`;

export const CookieAcceptArrowWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  margin: auto 0;
`;

export const CookieAcceptArrow = styled.img`
  display: inline;
  filter: invert(1);
  transform: translateZ(0px);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  ${NonSelectable};
  ${CalculateFromWidth("margin-left", { mobile: 1.1, tablet: 0.7, desktop: 0.6 })}
  ${CalculateFromHeight("height", { mobile: 2.1, tablet: 1.3, desktop: 1.2 })}
`;
export const CookieText = styled.p`
  ${StandardFont}
  ${({ theme: { breakpoints } }) => breakpoints.tabletMobile} {
    text-align: center;
    grid-row: 1 / span 1;
    grid-column: 1 / span 2;
    margin-top: auto;
    margin-bottom: auto;
  }
  ${({ theme: { breakpoints } }) => breakpoints.desktop} {
    margin-top: auto;
    margin-bottom: auto;
  }
  ${CalculateFontSize("font-size", { mobile: 1.2, tablet: 1.2 })}
  ${CalculateFromWidth("margin-left", { mobile: 5, tablet: 5 })}
  ${CalculateFromHeight("padding-top", { desktop: 0.15 })}
  justify-content: center;
`;
export const CookieLink = styled(Link)`
  ${CommonLink};

  ${({ theme: { breakpoints } }) => breakpoints.mobile} {
    ${({ theme: { fonts } }) => fonts.regular};
  }
  ${CalculateFontSize("font-size", { mobile: 1.2, tablet: 1.2 })}
  ${({ theme: { breakpoints } }) => breakpoints.tabletDesktop} {
    ${({ theme: { fonts } }) => fonts.regular};
  }
`;
